export default function(t){try{return"object"==typeof JSON.parse(t)}catch(t){return!1}}
